module.exports = __webpack_public_path__ + "static/banner_modale_premium-e23fea8ef4d3280b5b930292dc5e05b5.png";